import {Component} from '@angular/core';
import {Role} from '../../model/auth/Role';
import {CompetitionService} from '../../service/competition.service';
import {Competition} from '../../model/competition/Competition';
import {NotificationHandler} from '../../helper/notification.handler';
import {LocalStorageService} from 'ngx-webstorage';
import {MobileAwareComponent} from '../../common/mobile-aware/mobile-aware.component';
import {BreakpointObserver} from '@angular/cdk/layout';
import {
  CompetitionDetailsData,
  CompetitionDetailsModalComponent
} from '../competition-details-modal/competition-details-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {TenantService} from '../../service/tenant.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-competition-details',
  templateUrl: './competition-details.component.html',
  styleUrls: ['./competition-details.component.scss']
})
export class CompetitionDetailsComponent extends MobileAwareComponent {

  readonly roles = [Role.Host, Role.Coordinator, Role.Teacher, Role.Student];

  competition?: Competition;
  inProgress = false;

  editAllowed = true;

  constructor(private competitionService: CompetitionService,
              private localStorageService: LocalStorageService,
              private tenantService: TenantService,
              private dialog: MatDialog,
              public sanitizer: DomSanitizer,
              breakpointObserver: BreakpointObserver) {
    super(breakpointObserver);
  }

  initContent() {
    const tenant = this.tenantService.getTenant();
    if (tenant && tenant.id) {
      this.loadCompetition(tenant.id);
    }
  }

  private loadCompetition(id: string) {
    this.competition = undefined;
    this.inProgress = true;

    this.competitionService.getDetails(id).subscribe(competition => {
      this.competition = competition;
      this.inProgress = false;
    }, error => {
      NotificationHandler.handleError($localize`:Notifications|Competition details fetch has failed message@@notifications-competition-details-fetch-failed-error:Competition details fetch has failed`, error);
      this.inProgress = false;
    });
  }

  editCompetition() {
    this.dialog.open(CompetitionDetailsModalComponent, {
      width: '600px',
      data: {
        competition: this.competition
      }
    }).afterClosed().subscribe((data: CompetitionDetailsData) => {
      if (data && data.competition) {
        this.loadCompetition(data.competition.id);
      }
    });
  }

  rolesUpdated(roles: Role[]) {
    this.editAllowed = roles.includes(Role.Host);
  }
}
